import React from 'react';
import { Navigate, useRoutes } from "react-router-dom";
import ReactSuspenseContainer from "containers/ReactSuspense.container";
import { useDispatch } from 'react-redux';
import { removeToken } from 'redux/actions/token';
import ContextAuth from 'contexts/Auth.context';
const LazyLogin = React.lazy(() => import("components/Login"));
const LazySignup = React.lazy(() => import("components/Signup"));
const LazyEmailVerify = React.lazy(() => import("components/EmailVerify"));
const LazyForgotPassword = React.lazy(() => import("components/ForgotPassword"));
const LazyTerms = React.lazy(() => import("components/Terms"));

const LazySetupPassword = React.lazy(() => import("components/SetupPassword"));
const LazyRecoveryPassword = React.lazy(() => import("components/RecoveryPassword"));


const AuthRouter = () => {
  const { session, initDataLogin } = ContextAuth();
  const dispatch = useDispatch();
  const removeTokenAction = () => dispatch(removeToken());

  const routes = [
    {
      path: "/Login",
      element: <ReactSuspenseContainer>
        <LazyLogin session={session} changeUser={initDataLogin} />
      </ReactSuspenseContainer>,
    },
    {
      path: "/Signup",
      element: <ReactSuspenseContainer>
        <LazySignup />
      </ReactSuspenseContainer>,
    },
    {
      path: "/Email-Verify/:tokenUser",
      element: <ReactSuspenseContainer>
        <LazyEmailVerify removeToken={removeTokenAction} changeUser={initDataLogin} />
      </ReactSuspenseContainer>,
    },
    {
      path: "/Forgot-Password",
      element: <ReactSuspenseContainer>
        <LazyForgotPassword />
      </ReactSuspenseContainer>,
    },
    {
      path: "/setup-password/:token",
      element: <ReactSuspenseContainer>
        <LazySetupPassword
          removeToken={removeTokenAction}
          changeUser={initDataLogin}
        />
      </ReactSuspenseContainer>,
    },
    {
      path: "/Recovery-Password/:token",
      element: <ReactSuspenseContainer>
        <LazyRecoveryPassword
          removeToken={removeTokenAction}
          changeUser={initDataLogin}
        />
      </ReactSuspenseContainer>,
    },
    {
      path: "/Terms",
      element: <ReactSuspenseContainer>
        <LazyTerms />
      </ReactSuspenseContainer>,
    },
    {
      path: "*",
      element: <Navigate to="/Login" />,
    },
  ];

  return useRoutes(routes);
}

// const AuthRouter = ({ removeTokenAction, initDataLogin }) => {
//   return (
//     <Routes>
//       <Route
//         path="/Login"
//         element={
//           <LazyLogin
//             removeToken={removeTokenAction}
//             changeUser={initDataLogin}
//           />
//         }
//       />
//       <Route
//         path="/Signup"
//         element={
//           <LazySignup
//             removeToken={removeTokenAction}
//             changeUser={initDataLogin}
//           />
//         }
//       />
//       <Route
//         path="/Email-Verify/:tokenUser"
//         element={
//           <LazyEmailVerify removeToken={removeTokenAction} changeUser={initDataLogin} />
//         }
//       />
//       <Route
//         path="/setup-password/:token"
//         element={
//           <LazySetupPassword changeUser={initDataLogin} />
//         }
//       />
//       <Route
//         path="/Forgot-Password"
//         element={
//           <LazyForgotPassword
//             removeToken={removeTokenAction}
//             changeUser={initDataLogin}
//           />
//         }
//       />
//       <Route
//         path="/Terms"
//         element={
//           <LazyTerms
//             removeToken={removeTokenAction}
//             changeUser={initDataLogin}
//           />
//         }
//       />
//       <Route path="*" element={<Navigate to="/Login" />} />
//     </Routes>
//   );
// };

export default AuthRouter;